export const MfaOption = {
  NotEnabled: 0,
  AllUsers: 1,
  AllAdmins: 2,
  SelectedUsers: 3,
  SelectedTeams: 4,
  SelectedRoles: 5,
};

export const MfaAuthenticatorApp = {
  Microsoft: 1,
  Google: 2,
  Salesforce: 3,
  LastPass: 4,
  Authy: 5,
  Other: 100,
};

export const ScriptNamespaceType = {
  Gac: 0,
  File: 1,
};

/**
 * SC-1646: masks the server substitutes for a secure global variable's value. Must match
 * Constants.EncryptedGlobalPlaceholder / EncryptedGlobalUserPlaceholder in
 * SmartConnect.Engine.Shared/Constants.cs - they round-trip, and the save uses them to tell an
 * untouched value from a cleared one.
 *
 * GLOBAL  - this map uses the global variable's value.
 * USER    - this map has its own value.
 */
export const ENCRYPTED_GLOBAL_PLACEHOLDER = '######hidden-global-value######';
export const ENCRYPTED_GLOBAL_USER_PLACEHOLDER = '######hidden-global-user-value######';
